import { Omit } from '@40seas/entities/common';
import { SegmentEntityFieldsArray } from '@40seas/models';
import { PlaidAccessToken } from '@40seas/entities/plaid';

export class CreatePlaidAccessTokenDto extends Omit(PlaidAccessToken, SegmentEntityFieldsArray) {}
